<template>
  <v-app>
    <v-main v-if="!dataloader">
      <div
        v-if="geomessage && handleshowmsg && requestdomain"
        class="text-white f-size-14 d-flex justify-content-between align-center px-5 py-1"
        style="background-color: #005672"
      >
        <div>
          <span>{{ msgData }}</span>
          <span
            @click="routerDomain()"
            class="border-bottom border-1 fw-500 ms-1"
            style="cursor: pointer"
          >
            {{ requestdomain }}
          </span>
        </div>
        <div>
          <v-icon
            @click="geomessage = false"
            color="red"
            class="bg-white rounded-circle"
          >
            mdi-close-circle-outline
          </v-icon>
        </div>
      </div>

      <div>
      <div v-if="robotweb">
        <div v-if="whatsappApi && !isMobile">
          <a :href="whatsappApi" class="whatsapp-float" target="_blank" rel="noopener noreferrer">
            <v-icon class="whatsappImg" size="40">mdi-whatsapp</v-icon>
          </a>
        </div>
        </div>

        <!-- <div v-if="isMobile" class="custom-chat-button" @click="toggleChatDropdown">
          <v-icon size="30">mdi-chat</v-icon>
        </div> -->
        <div id="navbar" v-if="navbar && (!b2bPortal || ['/bookingConfirmation', '/bookingView'].includes($route.path))" v-show="!hideHeaderFooter">
          <headerCom1 @localChanged="updateLocale" />
        </div>
        <!-- <HomeComponent v-if="!otherpageRender" /> -->
        <div class="bg-pages">
          <!-- Keyed on the full URL so every navigation still mounts a fresh page,
               as it did when the whole app was unmounted between pages. -->
          <router-view :key="$route.fullPath" />
        </div>
        <div v-if="isMobile" class="container-wrapper d-md-none d-flex flex-column" :class="{ 'expanded': isExpanded }">
          <div class="content-panel" @click="togglePanel">
            <div v-if="tawktoApi" class="social-link mb-1" :class="{ 'expanded-link': isExpanded }">
              <v-icon class="whatsapp-float1 social-icon" :class="{ 'expanded-icon': isExpanded }" color="white" @click="handleClick1(whatsappApi)">mdi-whatsapp</v-icon>
            </div>
            <div 
              v-for="(data, index) in social_media" 
              :key="index" 
              class="social-link mb-1"
              :class="{ 'expanded-link': isExpanded }"
            >
              <v-icon class="social-icon" :class="{ 'expanded-icon': isExpanded }" color="white" @click="handleClick(data)">{{ data.icon_class}}</v-icon>
            </div>
          </div>

          <!-- <div
            class="share-icon" 
            @click="togglePanel"
            :class="{ 'move-right': showPanel,'facebook-move-right': showPanel && visibleIcon === 'facebook' }"
          >
            <v-icon color="white">mdi-share-variant</v-icon>
          </div> -->
        </div>
        <div v-if="!tawktoApi">
            <a v-if="!tawktoApi" :href="whatsappApi" class="d-none whatsapp-float" target="_blank" rel="noopener noreferrer">
            <v-icon class="whatsappImg" size="40">mdi-whatsapp</v-icon>
          </a>
          </div>

        <div id="food" v-if="food && (!b2bPortal || ['/bookingConfirmation', '/bookingView'].includes($route.path))" v-show="!hideHeaderFooter">
          <footerCom/>
        </div>
      </div>

    </v-main>
    <v-dialog v-model="portalError" persistent>
      <div class="d-flex justify-center">
        <v-card class="p-4">
          <h3 class="text-center">Oops! Site is being updated.</h3>
          <h5 class="text-center">Sorry for the inconvenience. We will be right back with exciting new features.</h5>
          <h6 class="text-center">Please visit again after some time.</h6>
          <div class="d-flex justify-space-evenly mt-3">
            <v-btn @click="reloadPage()" color="#162849">Retry</v-btn>
          </div>
        </v-card>
      </div>
    </v-dialog>
    <div v-if="dataloader">
      <dataloader></dataloader>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import headerCom1 from "@/components/headerCom.vue";
// import aboutUs from "@/components/aboutUs.vue";
import country1 from "@/coundtrycode.json";
import CryptoJS from "crypto-js";
import moment from "moment";

// import HomeComponent from './components/HomeComponent.vue';
import footerCom from "@/components/footerCom.vue";
import dataloader from "@/components/loaderComponent.vue"

import { setConfigDataToLocalStorage, getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
import { useHead } from '@vueuse/head'
import { perfStart, perfMark, perfEnd } from "@/utils/perf";
import { fetchCurrencyRatio } from "@/utils/currencyConversion";

export default {
  name: "App",
  components: {
    headerCom1,
    dataloader,
    footerCom,
  },
  data: () => ({
    isExpanded: false,
    dataloader:true,
    otherpageRender:false,
    portalError:false,
    showPanel: false,
    displayType:false,
    visibleIcon:null,
    togglemedia:false,
    dialog1: false,
    navbar: true,
    food: true,
    datashow: false,
    countryname: "",
    loading: true,
    visitcountryname: "",
    b2bPortal:"",

    dataDomainData: "",
    SearchDomain: "",
    portalsiteTitle: "",
    domaintrue: false,
    geomessage: false,
    msgData: "",
    requestdomain: "",
    handleshowmsg: false,
    findpage: false,
    userDomain: "",
    envPortalCalled: false,

    countryOptions: [],
    siteContentData: "",
    languageData: "",
    getLanguages: "",
    countryIsocode: "",

    configReq: {
      service_type: "GetPortalConfigRQ",
      api_ver: "1",
      payload: {
        domain_name: "",
        env: "CERT",
        language: "EN",
        token: "jsdjOJDKJ7675",
      },
    },

    configUser_Id: "",
      isMobile: false,
      tawktoApi: "",
    i18nlocaleLang: "",
    getEndpoint: "",
    loaderReq: {
      payload: {
        domain: "b2bportal.manninternationaltravel.com",
        etoken: "d9781f79c8e577d068587e0aca400e28",
      },
    },
    loaderApi: "https://otaget.nexus2.wistirna.com",
    whatsappApi: "",
    robotweb:true,
    metahead:false,
    social_media:[],
    showChatOptions: false,
    tawktoWidgetVisible: false,
    settingsPanelOpen: false,
    redirectReq: {
      payload: {
        requestdomain: "",
        portalname: "",
        portaloriginname: "",
        requesttype: "",
      },
    },
  }),

  computed: {
    // Pages that show without the site header and footer. They stay in the
    // page (v-show), only hidden, so code that looks them up still finds them.
    hideHeaderFooter() {
      return ["/bookingView", "/bookingConfirmation"].includes(this.$route.path);
    },
  },

  methods: {
    reloadPage() {
      setTimeout(() => {
        location.reload();
      }, 300);
      window.location.href = '/';
      this.portalError = false;
    },
    togglePanel() {
      this.isExpanded = !this.isExpanded;
    },
     handleClick(data) {
      // this.expandedIcon = this.expandedIcon === data.type ? null : data.type;
      window.open(data.url, "_blank");
    },
    handleClick1(data){
      window.open(data, "_blank")
    },
    routerDomain() {
      let routeredirectid = null;
      if (this.$route.query && this.$route.query.authreqid) {
        try {
          routeredirectid = this.$route.query.authreqid || null;
        } catch (e) {
          console.log("Invalid route redirectid value:", this.$route.query);
          routeredirectid = null;
        }
      }

      if (!routeredirectid) {
        window.location.href = this.userDomain;
      } else {
        // sessionStorage.setItem("redirectId",routeredirectid)
        window.location.href = `${this.userDomain}`;
      }
    },
    
    updateLocale(newLocale) {
      // Update the app's locale based on the event received from headerCom1.vue
      this.i18nlocaleLang = newLocale;
      // console.log("App locale updated to:", this.i18nlocaleLang);
    },

    async getloaderPortal() {
      let hostname = window.location.hostname;
      // let domainname  = window.location.origin;

      if (hostname == "localhost") {
        // console.log(hostname, "localhost....");
      } else {
        this.loaderReq.payload.domain = hostname;
      }

      let Key = "8dsxBc9vDl4I9alHbJU7Dg4EBbr7AS0w";
      let domain_name = this.loaderReq.payload.domain;
      // console.log(domain_name, "domain_nameeeee");
      let current_date = moment(new Date()).format("YYYYMMDD");
      let fixed_value = 3;

      // console.log(current_date,'dasafsdfdasdasd');

      let compineskey =
        Key + domain_name + current_date + fixed_value.toString();
      const encryptedkey = CryptoJS.MD5(compineskey).toString();

      this.loaderReq.payload.etoken = encryptedkey;

      // console.log(this.loaderReq,'loderred...2');

      await axios.post(this.loaderApi, this.loaderReq, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.response_type === "success") {
            this.getEndpoint = response.data.endpoint;
            this.portalError = false;
            if(this.getEndpoint && !this.envPortalCalled){
              this.envPortal(true);
              this.envPortalCalled = true;
            }
          }
        })
        .catch((error) => {
          console.log("Error fetching application:", error);
          this.dataloader = true;
          setTimeout(()=>{
            this.portalError = true;
          },3000)
        });
    },

    // Exchange rates for the search page conversion dropdown, fetched fresh right
    // after the portal config so they are ready before the first search. The base is
    // the agency's currency (?currency= on the agent portal link), else the portal's.
    loadCurrencyRatio(configData) {
      const portalConfig = configData?.payload?.portal_configuration;
      let agencyCurrency = "";
      try {
        agencyCurrency = JSON.parse(sessionStorage.getItem("agencyData"))?.currency || "";
      } catch (e) {
        agencyCurrency = "";
      }
      const baseCurrency =
        new URLSearchParams(window.location.search).get("currency") ||
        agencyCurrency ||
        portalConfig?.currency?.iso_code;
      fetchCurrencyRatio(portalConfig?.API_endpoints?.currency_ratio, baseCurrency, {
        refresh: true,
      });
    },

    async envPortal(handledredirect) {
      let hostname = window.location.hostname;
      if (hostname == "localhost") {
        this.configReq.payload.domain_name = this.loaderReq.payload.domain;
        console.log(hostname, "localhost....");
      } else {
        this.configReq.payload.domain_name = hostname;
      }

      // console.log(this.configReq, "configReqconfigReqconfigReq");

      // axios.get(`${this.getEndpoint}getportalconfig`, {
      axios.get(`https://otapi.manninternationaltravel.com/api/getportalconfig`, {
          params: this.configReq,
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then( async(response) => {
          perfMark("page load", "portal config fetched");
          if (response) {
            let configResponse = response.data;
            setConfigDataToLocalStorage(configResponse);

            const getConfigResponse = getConfigDataFromLocalStorage();

            if(getConfigResponse){
              this.loadCurrencyRatio(getConfigResponse);
              if (this.findpage && handledredirect) {
                let redirectId = sessionStorage.getItem("redirectId");
                let timeData = sessionStorage.getItem("mySessionKey_timestamp");
                if (!redirectId && !timeData) {
                  console.log('redirectionn')
                  this.geolocationDomain();
                } else {
                  this.dataloader = false;
                }
              } 
              else {
                this.dataloader = false;
              }
              // this.loading = true;
              // this.dataloader = false;
              // this.portalError = false;
              // // console.log(configResponse, "configResponseconfigResponse");
              
              // this.SearchDomain = this.configReq.payload.domain_name;
              // this.portalsiteTitle = configResponse.payload.portal_configuration.site_title;

              // this.countryname =
              //   configResponse.payload.portal_configuration.country.name;
              // let $dataname =
              //   configResponse.payload.portal_configuration.geoip_location
              //     .country_iso_code;

              // this.getLanguages =
              //   configResponse.payload.portal_configuration.languages;
              // this.countryOptions =
              //   configResponse.payload.portal_configuration.country_options;

              // this.languageData =
              //   configResponse.payload.portal_configuration.language_data;

              // this.countryIsocode =
              //   configResponse.payload.portal_configuration.country.iso_code;

              // // Geolocation Redirection
              // if(this.countryIsocode && this.countryOptions){
              //    this.geolocationDomain();
              // }
              //  // Geolocation Redirection End

              // if (this.languageData) {
              //   this.getlangaugeUrl();
              //   // this.localeLanguage();
              // } else {
              //   this.$i18n.locale = "CA-en";
              // }


              // if (this.getLanguages && this.countryIsocode) {
              //   this.setLanguage();
              //   // console.log("working...1");
              //   // this.$i18n.locale = `${this.countryIsocode}-${this.getLanguages[0].code}`
              //   // console.log(this.$i18n.locale, "langresponseresponse...1");
              // } else {
              //   this.$i18n.locale = "CA-en";
              //   // console.log("working...2");
              //   // this.$i18n.locale = `${this.countryIsocode}-${this.getLanguages[0].code}`
              // }

              // country1.forEach((v) => {
              //   if ($dataname == "US" || $dataname == "CA") {
              //     if (v.code == $dataname) {
              //       this.visitcountryname = v.name;
              //     }
              //   } else {
              //     this.visitcountryname = "Global";
              //   }
              // });

              // if (configResponse) {
              //   this.datashow = true;
              // }
              this.indexHeader();
            }
          }
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          // this.dialog1 = true;
          // alert(
          //   "Oops! Site is being updated. Sorry, for the inconvenience. We will be right back with exciting new features. Please visit again after some time."
          // );
          this.loading = false;
          this.dataloader = true;

          setTimeout(()=>{
            this.portalError = true;
          },3000)
        });
    },


    async geolocationDomain() {
      console.log("geolocationDomain");

      const getConfigResponse = getConfigDataFromLocalStorage();
      if (!getConfigResponse) return;

      let georedirectUrl =
        getConfigResponse.payload.portal_configuration.API_endpoints
          .georedirect;
      let portalurlconfig =
        getConfigResponse.payload.portal_configuration.portal_url;
      let portalgroupid =
        getConfigResponse.payload.portal_configuration.portal_group_id;
      let getuseriso =
        getConfigResponse.payload.portal_configuration.country.iso_code || null;
      let getcountryoptions =
        getConfigResponse.payload.portal_configuration.country_options || null;

      let portaldomain = portalurlconfig;
      let portaldomainname = portalurlconfig.replace("https://", "") || null;

      let getredirectid = null;
      let getrouteiso = null;
      let usercountryIso = null;
      let findcountry = null;
      let findportalurl = null;
      let findportalname = null;

      if (
        this.$route.query &&
        this.$route.query.authreq &&
        this.$route.query.authreqid
      ) {
        try {
          getrouteiso = this.$route.query.authreq || null;
          getredirectid = this.$route.query.authreqid || null;

          // Decrypt the country ISO code
          if (getrouteiso) {
            usercountryIso =
              CryptoJS.enc.Base64.parse(getrouteiso).toString(
                CryptoJS.enc.Utf8
              ) || null;
          }

          if (usercountryIso && getcountryoptions) {
            findcountry =
              getcountryoptions.find((v) => v.country_code == usercountryIso) ||
              null;
            findportalurl = findcountry ? findcountry.portal_url : null;
            findportalname = findcountry
              ? findcountry.portal_url.replace("https://", "")
              : null;
          }
        } catch (e) {
          console.log("Invalid redirectid value:", this.$route.query);
          getrouteiso = null;
          getredirectid = null;
        }
      } else if (
        this.$route.query &&
        this.$route.query.authreqid &&
        !this.$route.query.authreq
      ) {
        try {
          getredirectid = this.$route.query.authreqid || null;
        } catch (e) {
          console.log("Invalid redirectid value:", this.$route.query);
          getredirectid = null;
        }
      } else {
        getredirectid = null;
        getrouteiso = null;
      }

      let getredirecttype = null;
      if (this.$route.query && this.$route.query.redirect) {
        try {
          getredirecttype = JSON.parse(this.$route.query.redirect);
        } catch (e) {
          console.log(
            "Invalid redirect type value:",
            this.$route.query.redirect
          );
          getredirecttype = null;
        }
      }

      // let localorigin = window.location.origin || null;
      // if (localorigin && localorigin.includes("localhost")) {
      //   this.redirectReq.payload.ip = "";
      // }

      this.redirectReq.payload.requestdomain =
        findportalurl && getredirectid ? findportalurl : portaldomain;
      this.redirectReq.payload.portalname =
        findportalname && getredirectid ? findportalname : portaldomainname;
      this.redirectReq.payload.portaloriginname = portalgroupid;
      this.redirectReq.payload.requesttype = getredirecttype
        ? "manual"
        : "auto";
      if (getredirectid) this.redirectReq.payload.redirectid = getredirectid;

      if (georedirectUrl) {
        axios
          .post(georedirectUrl, this.redirectReq, {
            headers: { "Content-Type": "application/json" },
          })
          .then((response) => {
            let getresponse = response.data;
            console.log(getresponse, "getresponse");
            let geohandleredirect = getresponse.redirect || null;
            let georedirectdomain = getresponse.redirect_domain || null;
            let georedirectId = getresponse.redirectid || null;
            this.handleshowmsg = getresponse.show_msg || null;

            if (
              geohandleredirect &&
              georedirectdomain &&
              georedirectId &&
              getuseriso
            ) {
              let encryptiso = CryptoJS.enc.Base64.stringify(
                CryptoJS.enc.Utf8.parse(getuseriso)
              );
              if (encryptiso) {
                // localStorage.setItem("lastVisitTime", new Date().toISOString()); // Store visit time before redirection
                sessionStorage.setItem("redirectId", georedirectId);
                sessionStorage.setItem("hasRedirected", "true");
                this.handleSessionTimeout();
                window.location.href = `${georedirectdomain}?authreq=${encryptiso}&authreqid=${georedirectId}`;
              }
            } else if (
              !geohandleredirect &&
              this.handleshowmsg &&
              getrouteiso &&
              getredirectid
            ) {
              this.msgData = getresponse.message.text;
              this.geomessage = getresponse.message.text;
              this.userDomain = getresponse.message.url;
              const getuserdomain = this.userDomain.replace("https://", "");
              const trimedDomain =
                getuserdomain.charAt(0).toUpperCase() + getuserdomain.slice(1);
              this.requestdomain = trimedDomain;
              console.log(this.requestdomain, "requestdomain");
              this.dataloader = false;
            } else {
              this.dataloader = false;
              // localStorage.removeItem("lastVisitTime", new Date().toISOString()); // Store visit time if no redirection
              this.handleSessionTimeout();
            }
          })
          .catch((error) => {
            this.findpage = false;
            this.dataloader = false;
            this.envPortal(null);
            console.log(error, "Error during redirection");
          });
      } else {
        this.dataloader = false;
        this.envPortal(null);
      }
    },
    handleSessionTimeout() {
      const keyName = "mySessionKey"; // Your session key
      const storedTimestamp = sessionStorage.getItem(`${keyName}_timestamp`);
      const currentDomain = window.location.hostname;
      const storedDomain = sessionStorage.getItem("storedDomain");

      if (storedTimestamp) {
        const formattedTime = new Date(
          parseInt(storedTimestamp)
        ).toLocaleString();
        console.log("Stored Time:", formattedTime);
      }

      // If domain changed, reset session data
      if (storedDomain !== currentDomain) {
        sessionStorage.removeItem(`${keyName}_timestamp`);
        sessionStorage.setItem("storedDomain", currentDomain);
        console.log("Domain changed. Resetting session.");
      }

      // Set timestamp if not already stored
      if (
        !storedTimestamp &&
        sessionStorage.getItem("hasRedirected") === "true"
      ) {
        sessionStorage.setItem(`${keyName}_timestamp`, Date.now().toString());
        console.log("Session timestamp set.");
      }
      // if (storedTimestamp) {
      //   const date = new Date(parseInt(storedTimestamp));
      //   const formattedTime = new Intl.DateTimeFormat("en-US", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     second: "2-digit",
      //     hour12: true,
      //   }).format(date);

      //   console.log("Stored Time:", formattedTime);
      // }

      // Check and clear session after 1 hour
      setInterval(() => {
        const savedTime = sessionStorage.getItem(`${keyName}_timestamp`);
        if (savedTime && Date.now() - parseInt(savedTime) > 3600000) {
          sessionStorage.removeItem(`${keyName}_timestamp`);
          sessionStorage.removeItem("redirectId");
          sessionStorage.removeItem("hasRedirected");
          console.log("Session expired. Clearing session data.");
        }
      }, 10000);
    },
    loadGtag(gtagId) {
      if (!gtagId) return;

      const exists = document.querySelector(`script[src*="gtag/js?id=${gtagId}"]`);
      if (exists) {
        console.log('GTAG already loaded');
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
      document.head.appendChild(script);

      script.onload = () => {
        console.log('GTAG script loaded');
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', gtagId);
      };

      script.onerror = () => {
        console.error('Failed to load GTAG script');
      };
    },


    indexHeader() {
      const getConfigData = getConfigDataFromLocalStorage();

      if (getConfigData) {
        let portalTitle = getConfigData.payload.portal_configuration.site_title;
        let portalFavicon = getConfigData.payload.portal_configuration.favicon;
        this.social_media = getConfigData.payload.portal_configuration.social_icons;
        let portal_url= getConfigData.payload.portal_configuration.portal_url
        this.metaDate=getConfigData.payload.portal_configuration.seo_data?.seo_data 
        const portalUrl = getConfigData.payload.portal_configuration.portal_url || '';
        if (portalUrl.includes('b2bportal')) {
          this.b2bPortal = true;
        } else {
          this.b2bPortal = false;
        }     
              // console.log(configResponse, "configResponseconfigResponse");
              
              this.SearchDomain = this.configReq.payload.domain_name;
              this.portalsiteTitle = getConfigData.payload.portal_configuration.site_title;

              this.countryname =
                getConfigData.payload.portal_configuration.country.name;
              let $dataname =
                getConfigData.payload.portal_configuration.geoip_location
                  .country_iso_code;

              this.getLanguages =
                getConfigData.payload.portal_configuration.languages;
              this.countryOptions =
                getConfigData.payload.portal_configuration.country_options;

              this.languageData =
                getConfigData.payload.portal_configuration.language_data;

              this.countryIsocode =
                getConfigData.payload.portal_configuration.country.iso_code;
                this.loading = true;
              // this.dataloader = false;
              this.portalError = false;

              if (this.languageData) {
                // this.getlangaugeUrl();
                // this.localeLanguage();
                this.$i18n.locale = "CA-en";
              } else {
                this.$i18n.locale = "CA-en";
              }


              if (this.getLanguages && this.countryIsocode) {
                this.setLanguage();
                // console.log("working...1");
                // this.$i18n.locale = `${this.countryIsocode}-${this.getLanguages[0].code}`
                // console.log(this.$i18n.locale, "langresponseresponse...1");
              } else {
                this.$i18n.locale = "CA-en";
                // console.log("working...2");
                // this.$i18n.locale = `${this.countryIsocode}-${this.getLanguages[0].code}`
              }

              country1.forEach((v) => {
                if ($dataname == "US" || $dataname == "CA") {
                  if (v.code == $dataname) {
                    this.visitcountryname = v.name;
                  }
                } else {
                  this.visitcountryname = "Global";
                }
              });

              if (getConfigData) {
                this.datashow = true;
              }
        // console.log(this.metaDate,getConfigData.payload.portal_configuration.seo_data?.seo_data,'this.metaDate')
        if(this.metaDate){
          this.metaDate.forEach((c) => {
          // console.log(c, '000');
      
            if (c.name === "title" || c.name === "sitemap") {
                delete c.name;
                delete c.content;
            } else if (typeof c.name === "string" && c.name.includes("robot_txt")) {
                c.name = `${portal_url}/robots.txt`;
            }
        
            if (typeof c.name === "string") {
                c.name = c.name.replace("meta_", "");
            }
        
            delete c.label;
            delete c.type;
          });
        }

      if(this.metahead){
        useHead({
          meta:this.metaDate
        })
      }

      if(this.robotweb){


        let enabledPlugins = "";
        enabledPlugins = getConfigData.payload.portal_configuration.menus.enabled.plugins;
       


        if (enabledPlugins.includes("whatsapp")) {
          this.whatsappApi = getConfigData.payload.portal_configuration.API_endpoints.whatsapp;
        } else {
          this.whatsappApi = "";
        }
        if (enabledPlugins.includes("tawkto")) {
          this.tawktoApi =
           getConfigData.payload.portal_configuration.API_endpoints.tawkto;
        } else {
          this.tawktoApi = "";
        }

        // console.log(
        //   this.languageData,
        //   "siteContentDatasiteContentDatasiteContentData"
        // );

        document.getElementById("siteTitle").innerText = portalTitle;
        document.getElementById("faviconPortal").href = portalFavicon;

        // TawkTo code. indexHeader() runs twice when the page starts from the
        // saved config, so add the script only once.
        const tawkLoaded = Array.from(document.scripts).some(
          (s) => s.getAttribute("src") === this.tawktoApi
        );
        if (this.tawktoApi && !tawkLoaded) {
          const s1 = document.createElement("script");
          const s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = this.tawktoApi;
          s1.charset = "UTF-8";
          s1.setAttribute("crossorigin", "*");
          s0.parentNode.insertBefore(s1, s0);
        }
      }
      let gtm_enable = getConfigData.payload.portal_configuration.gtm_enable || false;
      let gtm_id = getConfigData.payload.portal_configuration.gtm_id || '';
      console.log(gtm_enable,gtm_id,'gtmdataas')
      if (gtm_enable && gtm_id) {
        this.loadGtag(gtm_id)
      }
      }
    },

   checkIfMobile() {
      // const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 480; // Adjust breakpoint as needed

      // Handle position changes when switching between mobile and desktop
      // if (wasMobile !== this.isMobile) {
      //   this.updateTawkToPosition();
      // }
    },
  //   toggleChatDropdown() {
  //     this.showChatOptions = !this.showChatOptions;

  //     // Toggle Tawk.to widget visibility in mobile mode
  //     if (this.isMobile) {
  //       this.tawktoWidgetVisible = this.showChatOptions;
  //       this.toggleTawkToVisibility();
  //       this.updateTawkToPosition();
  //     }
  //   },
  //   includeTawkToScript() {
  //     // Define Tawk_API globally with customStyle
  //     window.Tawk_API = window.Tawk_API || {};
  //     window.Tawk_API.onLoad = () => this.updateTawkToPosition();

  //     // Dynamically include the Tawk.to script
  //     const tawkScript = document.createElement("script");
  //     tawkScript.src = this.tawktoApi; // Replace with your Tawk.to property ID
  //     tawkScript.async = true;
  //     tawkScript.charset = "UTF-8";
  //     tawkScript.setAttribute("crossorigin", "*");
  //     document.body.appendChild(tawkScript);
  //   },
    // updateTawkToPosition() {
    //   if (window.Tawk_API) {
    //     // Define custom styles for desktop and mobile
    //     window.Tawk_API.customStyle = {
    //       visibility: {
           
    //         mobile: {
    //           position: "cr",
    //           xOffset: "10px", // Horizontal offset for mobile
    //           yOffset: 190,     // Vertical offset for mobile
    //         },
    //          desktop: {
    //           position: "br",
    //           xOffset: "30px", // Horizontal offset for desktop
    //           yOffset: 20,     // Vertical offset for desktop
    //         }
    //       },
    //     };
    //      if (this.isMobile) {
    //       window.Tawk_API.customStyle.visibility = {
    //         position: "cr",
    //         xOffset: "10px",
    //         yOffset: 190,
    //       };
    //     } else {
    //       window.Tawk_API.customStyle.visibility = {
    //         position: "br",
    //         xOffset: "30px",
    //         yOffset: 20,
    //       };
    //     }

    //     // Ensure the position updates are applied
    //     window.Tawk_API.customStyles = window.Tawk_API.customStyle;
    //      setTimeout(() => {
    //       window.Tawk_API.customStyles = window.Tawk_API.customStyle;
    //     }, 200);
    //   }
    //   console.log(window.Tawk_API.customStyles,'isMobile...1')
    //   console.log(window.Tawk_API,'isMobile...1')
    // },
    //  updateTawkToPosition() {
    // if (window.Tawk_API) {
    //   // Ensure the widget container gets the custom styles with !important to override default
    //   const widget = document.querySelector(".tawk-chat-container");
    //   if (widget) {
    //     widget.style.position = "absolute !important";
    //     widget.style.right = this.isMobile ? "10px !important" : "30px !important";
    //     widget.style.bottom = this.isMobile ? "190px !important" : "20px !important";
    //   }

    //   // Optionally, log for debugging
    //   console.log("Custom position applied: ", {
    //     position: this.isMobile ? "cr" : "br",
    //     right: this.isMobile ? "10px" : "30px",
    //     bottom: this.isMobile ? "190px" : "20px",
    //   });
    // }
    // },
    // toggleTawkToVisibility() {
    //   // Show or hide the Tawk.to widget dynamically
    //   if (window.Tawk_API) {
    //     if (this.tawktoWidgetVisible) {
    //       window.Tawk_API.showWidget();
    //       this.updateTawkToPosition();
    //     } else {
    //       window.Tawk_API.hideWidget();
    //       // try{
    //       // }
    //       // catch(e){
    //       //   console.log("hideWidget not working!");
    //       // }
    //     }
    //   }
    // },


    setLanguage() {
      let getLang = this.getLanguages[0].code;
      let savedLanguage = `${this.countryIsocode}-${getLang}`;
      localStorage.setItem("setlang", savedLanguage);
      // let setlocalLang = localStorage.setItem("setlang", savedLanguage);
      // if(setlocalLang){
      //   this.localeLanguage();
      // }
    },
    localeLanguage() {
      const storedLocale = localStorage.getItem("defaultlang");
      const storedSetLang = localStorage.getItem("setlang");

      let getlocalIso = "";
      let getlocalLang = "";
      let getsetIso = "";
      let getsetlang = "";
      // let savedLanguage = "";

      if (storedLocale) {
        getlocalIso = storedLocale.split("-")[0];
        getlocalLang = storedLocale.split("-")[1];
      }
      if (storedSetLang) {
        getsetIso = storedSetLang.split("-")[0];
        getsetlang = storedSetLang.split("-")[1];
      }

      if (storedSetLang && storedLocale) {
        // console.log("Check...1");
        if (storedLocale == storedSetLang) {
          // console.log("Check...2");

          return storedSetLang;
          // this.i18n.locale = storedSetLang;
        } else if (storedLocale !== storedSetLang) {
          // console.log(
          //   getlocalIso,
          //   getsetIso,
          //   "Check...3",
          //   getlocalLang,
          //   getsetlang
          // );
          if (getlocalIso !== getsetIso && getlocalLang !== getsetlang) {
            localStorage.removeItem("defaultlang");
            // console.log("Check...4");
            return storedSetLang;
            // this.i18n.locale = storedSetLang;
          } else if (getlocalIso == getsetIso && getlocalLang !== getsetlang) {
            // console.log(storedLocale, "Check...5");

            return storedLocale;
            // this.i18n.locale = storedLocale;
          }
        }
      } else if (storedSetLang) {
        // console.log("Check...6");

        return storedSetLang;
        // this.i18n.locale = storedSetLang;
      } else if (storedLocale) {
        // console.log("Check...7");

        return storedLocale;
        // this.i18n.locale = storedLocale;
      } else {
        // console.log("Check...8");

        return "CA-en";
        // return `${this.countryIsocode}-${this.getLanguages[0].code}`;

        // this.i18n.locale = `${this.countryIsocode}-${this.getLanguages[0].code}`;
      }
    },

    getlangaugeUrl() {
      let langData = this.languageData;
      // console.log(langData, 'languageDatalanguageDatalanguageData...1');
      // let getlocale = this.localeLanguage();
      // this.$i18n.locale = this.localeLanguage();
      var localLang = this.localeLanguage(); //CA.es

      // console.log(localLang, 'languageDatalanguageDatalanguageData...2');

      let langdataUrl = "";
      // console.log(localLang,'localLanglocalLang')
      Object.keys(langData).forEach((v) => {
        // console.log(
        //   v,
        //   this.countryIsocode,
        //   "languageDatalanguageDatalanguageData...3"
        // );
        if (v == this.countryIsocode) {
          const lang = langData[v];

          Object.keys(lang).forEach((local) => {
            // console.log(local, 'dasasasasdas')
            if (local == localLang) {
              langdataUrl = lang[local];
              // console.log(local, localLang, langdataUrl, "dasasasasdas...2");

              axios
                .get(langdataUrl, {
                  headers: {
                    "Content-Type": "text/html; charset=utf-8",
                  },
                })
                .then((response) => {
                  if (response) {
                    // this.aboutContent = response.data
                    // console.log(response, "langresponseresponse...2");
                    // console.log(response.data, "langresponseresponse");
                    const cleanedData = this.parseLanguageData(response.data);
                    this.setLanguageMessages(localLang, cleanedData);
                    // setInterval(() => {
                    //   location.reload();
                    // }, 500);
                    // this.dataloader = false;
                  }
                  // else {
                  //   this.$i18n.locale = `${this.countryIsocode}-${this.getLanguages[0].code}`
                  //   console.log(this.$i18n.locale, "langresponseresponse...1");
                  // }
                })
                .catch((error) => {
                  console.log(error, "errorrLangaugeAPI.....");

                  this.$i18n.locale = "CA-en";
                  this.dataloader = true;
                });
            }
          });
        }
      });
    },

    parseLanguageData(data) {
      try {
        const cleanedData = data
          .replace(/export\s+default\s+/, "")
          .replace(/;\s*$/, ""); // Remove trailing semicolon if present
        return eval(`(${cleanedData})`);
      } catch (error) {
        console.error("Error processing language content:", error);
        return {};
      }
    },

    setLanguageMessages(locale, messages) {
      this.$i18n.setLocaleMessage(locale, messages);
      this.$i18n.locale = locale;

      // console.log(this.$i18n.locale, "setLanguageMessagessetLanguageMessages");
    },
    handleOutsideClick(event) {
      if(!event.target.closest(".container-wrapper")){
        this.isExpanded = false;
      }
    }
  },
  mounted() {
    perfStart("page load", 0);
    perfMark("page load", "app mounted");

    // this.getloaderPortal();
    if (sessionStorage.getItem("hasRedirected") === "true") {
      this.handleSessionTimeout();
    }
    // Show the page with the config saved on the last visit; envPortal()
    // refreshes it in the background. First visits still wait for envPortal().
    let cachedConfig = null;
    try {
      cachedConfig = getConfigDataFromLocalStorage();
    } catch (e) {
      cachedConfig = null;
    }
    if (cachedConfig) {
      this.indexHeader();
      this.dataloader = false;
    }
    this.envPortal();
    // this.includeTawkToScript();
    // this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    document.body.addEventListener("click", this.handleOutsideClick);
    this.isMobile = window.innerWidth <= 480;
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIfMobile);
    document.body.removeEventListener("click", this.handleOutsideClick);
  },

  // created() {
  //   this.envPortal();
  //   // this.getRandomChars();

  //   setTimeout(() => {
  //     // this.indexHeader();
  //   }, 2000);
  // },

  watch: {
    dataloader(val) {
      if (!val) perfEnd("page load", "page shown");
    },
    isMobile(newVal) {
      // console.log(newVal,'isMobile')
      //  this.updateTawkToPosition();

      // Close chat options and hide widget when switching to mobile
      if (!newVal) {
        this.showChatOptions = false;
        this.tawktoWidgetVisible = true; // Always visible on desktop
        // this.updateTawkToPosition();
      } else {
        this.tawktoWidgetVisible = false; // Initially hidden on mobile
        // this.toggleTawkToVisibility();
      }
    },
    showChatOptions(newVal){
      console.log(newVal)
      this.updateTawkToPosition();
    },
    // i18nlocaleLang: {
    //   immediate: true,
    //   handler: function () {
    //     // this.localeLanguage();
    //     this.getlangaugeUrl();
    //   },
    //   // deep: true,
    // },
    "$route.path": {
    immediate: true,
    handler(newValue) {
      // console.log(newValue, 'newValue');

      // this.getloaderPortal();

      // Hide navbar and food for specific routes
      if (["/loader", "/robots.txt","/sitemap.xml"].includes(newValue)) {
        this.metahead=true
        this.navbar = false;
        this.food = false;
        this.robotweb=false;

        document.querySelectorAll('style[type="text/css"]').forEach((el) => el.remove());
      } else {
        this.navbar = true;
        this.food = true;
      }
      this.geomessage = newValue === "/" ? true : false;
      this.findpage = newValue === "/" ? true : false;
      // Router guards used to be added here on every path change. They hid the
      // whole app and waited 4 s on every navigation, and piled up over time.
    }
  }
  },
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300&family=Poppins:wght@300;400;500&display=swap");

* {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
}

#navbar {
  display: block;
}

#food {
  display: block;
}

.bg-pages {
  background: #f0f3f5;
  /* background-image:url('./assets/bmbg2.svg'); */
}
.whatsapp-float1{
  display:none;
}
.whatsapp-float {
  position: fixed;
  width: 55px;
  height: 52px;
  bottom: 115px;
  right: 30px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
  box-shadow: 1px 1px 2px #888;
}
v-icon:hover {
  color: white;
}
.whatsapp-float:hover {
  color: white;
}
a:visited {
  color: white !important;
}
/* .whatsapp-float img {
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
.whatsappImg {
  width: 45px;
  height: 45px;
}
.whatsappImg:hover {
  color: white;
}
.v-overlay-container .v-overlay__content {
  min-width: 0 !important;
}


.floating-icons {
  position: fixed;
  top: 78%;
  left: 10px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.floating-icons a {
  text-decoration: none;
  border-radius: 50%;
  background-color: #F07626; 
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  color: #fff;
  transition: background-color 0.3s, transform 0.3s;
}

.floating-icons a:hover {
  background-color: #F07626;
  transform: scale(1.1);
}
@media (max-width: 768px) {
  .floating-icons {
    display: flex;
  }
  .chat-float{
    display:block;
  }
}

@media (min-width: 769px) {
  .floating-icons {
    display: none;
  }
  .chat-float{
    display:none;
  }
}
@media (max-width:480px){
  .whatsapp-float{
    display:block;
    right:20px;
    bottom:18px;
  }
  .whatsapp-float1{
    display:flex;
  }
}

/* Floating Chat Button */
.custom-chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background-color: #005672;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.chat-options {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chat-option {
  background-color: #005672;
  color: white;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.whatsapp-float {
  background-color: #25d366;
}

.tawkto-float {
  background-color: #162849;
}
/* Wrapper for positioning */
.container-wrapper {
  position: fixed;
  /* top: 75%; */
  bottom:-1%;
  left: 3px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 1;
  transition: all 0.3s ease-in-out;
}

/* Content Panel */
.content-panel {
  display: flex;
  flex-direction: column;
  /* gap: 2px; */
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px 13px 10px 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
  position: fixed;
  /* top: 60px; */
  bottom:3px;
  left:3px;
}

/* Social Media Links */
.social-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F07626;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-decoration: none;
  /* transition: background-color 0.3s ease-in-out; */
  transition: all 0.3s ease-in-out;
}
.container-wrapper.expanded{
  bottom:-1%;
}
.social-link.expanded-link{
  width: 35px;
  height: 35px;
}
.social-icon{
  position:fixed;
  font-size:12px !important;
  width:13px;
  height:13px;
  transition: all 0.3s ease-in-out;
}
.social-icon.expanded-icon{
  font-size:20px !important;
}
.social-name{
  position: absolute;
  left: 37px;
  background-color: #F07626;
  padding: 4px 5px;
  font-size: 20px;
  border-radius: 5px;
}

.icon-name {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.social-link:hover .icon-name {
  display: block;
  opacity: 1;
  transform: translateX(-50%) translateY(5px); /* Adjust positioning as needed */
}
/* .social-link:hover {
  background-color: #007bff;
} */

/* Share Icon */
.share-icon {
  width: 45px;
  height: 45px;
  background-color: #F07626;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

/* Move Share Icon Right */
.share-icon.move-right {
  transform: translateX(25%);
}
.share-icon.facebook-move-right {
  transform: translateX(105px);
  transition: transform 0.3s ease;
}


</style>
